import { useState } from 'react'

type Mode = 'read' | 'edit'

interface UseEditModeReturn {
  mode: Mode
  isEditing: boolean
  handleEdit: () => void
  handleCancel: () => void
  handleSave: () => void
}

export function useEditMode(): UseEditModeReturn {
  const [mode, setMode] = useState<Mode>('read')

  return {
    mode,
    isEditing: mode === 'edit',
    handleEdit: () => setMode('edit'),
    handleCancel: () => setMode('read'),
    handleSave: () => setMode('read'),
  }
}
